
import { APIClient } from "../../../../api/api_helper";
import { MasterPeriod_API } from "../../../../api/url_helper";
import { GetUserData } from "../../../../common/service/CommonService";

interface CurrentUser {
  userid: number;

}

const api = new APIClient();


export const masterPeriodApiService = {
  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      status: "A",
      searchtext: searchText || null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };
    return api.create(MasterPeriod_API.MasterPeriod_API + "SelectAll", payload);
  },

  // SELECT METHOD
  getSelectData: (id: number | undefined | null) => {
    return api.create(MasterPeriod_API.MasterPeriod_API + "Select", {
      masterperiodid: id,
    });
  },

  insertData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      period_sort: payload_data.period_sort,
      period_number: payload_data.period_number,
      createdby: user.userid,
    };
    return api.create(MasterPeriod_API.MasterPeriod_API + "Insert", payload);
  },

  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      masterperiodid: payload_data.masterperiodid,
      period_sort: payload_data.period_sort,
      period_number: payload_data.period_number,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(MasterPeriod_API.MasterPeriod_API + "Update", payload);
  },

  // DELETE METHOD
  deleteData: (payload_data: {
    masterperiodid: number;
    updatereason: string;
  }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      masterperiodid: payload_data.masterperiodid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(MasterPeriod_API.MasterPeriod_API + "Delete", payload);
  },
};